import { AdsEnrichedVideoContext, AdsEnrichedVideoContextOverrider } from "@mp-commons/modules/ads/AdsEnrichedVideoContext.js";

let hasBeenManuallyStartedOnce: boolean = false;

/**
 * Extends {@link AdsEnrichedVideoContextOverrider} to provide additional functionality
 * for video contexts enriched with ads in the Megaride player.
 *
 * @remarks
 * This class wraps an existing {@link AdsEnrichedVideoContext} and exposes its
 * `isAdsEnriched` property. It overrides the `togglePlay` method to handle manual play
 * events and ensures the video is unmuted on the first manual start.
 *
 * @example
 * ```typescript
 * const context = new MegarideAdsEnrichedVideoContext(existingContext);
 * await context.togglePlay(true);
 * ```
 *
 * @public
 */
export class MegarideAdsEnrichedVideoContext extends AdsEnrichedVideoContextOverrider {
    
    public readonly isAdsEnriched: boolean;

    constructor(ctl: AdsEnrichedVideoContext) {
        super(ctl);
        this.isAdsEnriched = ctl.isAdsEnriched;
    }


    public togglePlay(manualPlay: boolean): Promise<boolean> {
        return this.originalContext.togglePlay(manualPlay).then(x => {
            if(!this.originalContext.isPaused &&
                manualPlay && 
                !hasBeenManuallyStartedOnce) {
                    hasBeenManuallyStartedOnce= true;
                    this.originalContext.unmute();
            }
            return x;   
        })
    }

}